import { Button, Card, Flex, Input, Space, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import InputNumber from 'components/input-number';
import { formatCurrency } from 'utils/number';
import { useOrderEditContext } from '../OrderEditContext';

const { Text } = Typography;

const SummaryRow = ({ label, value, editKey, showEditF, showEdit, children }) => {
    const isEditing = showEditF?.[editKey];

    return (
        <Flex
            justify='space-between'
            align='center'
            gap={8}
            style={{
                padding: '10px 0',
                borderBottom: '1px solid #f5f5f5',
                background: isEditing ? '#fafeff' : 'transparent',
                borderRadius: isEditing ? 6 : 0,
                paddingInline: isEditing ? 8 : 0,
                transition: 'all 0.2s',
            }}
        >
            <Flex align='center' gap={4}>
                <Text>{label}</Text>
                {editKey && (
                    <Button
                        type='text'
                        size='small'
                        icon={<EditOutlined />}
                        onClick={() => showEdit(editKey)}
                    />
                )}
            </Flex>
            <div style={{ textAlign: 'right' }}>
                {isEditing ? children : <Text>{value}</Text>}
            </div>
        </Flex>
    );
};

const OrderSummaryCardMobile = () => {
    const {
        data,
        form,
        navigate,
        showEditF,
        showEdit,
        onDiscountAmountChange,
        onShippingAmountChange,
        onLoyaltyPointChange,
        onVoucherCodeChange,
    } = useOrderEditContext();

    return (
        <Card size='small'>
            <Space direction='vertical' size={0} style={{ width: '100%' }}>
                <SummaryRow label='Tiền hàng' value={formatCurrency(data.sub_amount)} />

                <SummaryRow
                    label='Giảm giá'
                    value={formatCurrency(data.discount_amount)}
                    editKey='discount'
                    showEditF={showEditF}
                    showEdit={showEdit}
                >
                    <InputNumber
                        value={data.discount_amount}
                        onChange={onDiscountAmountChange}
                        showCalculator={false}
                        style={{ width: 140 }}
                    />
                </SummaryRow>

                <SummaryRow
                    label='Mã khuyến mãi'
                    value={
                        <Space size={4}>
                            {data.voucher_code && <Text code>{data.voucher_code}</Text>}
                            {data.voucher_amount > 0 && <Text>-{formatCurrency(data.voucher_amount)}</Text>}
                            {!data.voucher_code && !data.voucher_amount && <Text>—</Text>}
                        </Space>
                    }
                    editKey='voucher'
                    showEditF={showEditF}
                    showEdit={showEdit}
                >
                    <Input
                        value={data.voucher_code}
                        onChange={onVoucherCodeChange}
                        placeholder='Nhập mã'
                        style={{ width: 140 }}
                    />
                </SummaryRow>

                <SummaryRow
                    label='Xu'
                    value={formatCurrency(data.loyalty_point)}
                    editKey='point'
                    showEditF={showEditF}
                    showEdit={showEdit}
                >
                    <InputNumber
                        value={data.loyalty_point}
                        onChange={onLoyaltyPointChange}
                        showCalculator={false}
                        style={{ width: 140 }}
                    />
                </SummaryRow>

                <SummaryRow
                    label='Phí ship'
                    value={formatCurrency(data.shipping_amount)}
                    editKey='shiping'
                    showEditF={showEditF}
                    showEdit={showEdit}
                >
                    <InputNumber
                        value={data.shipping_amount}
                        onChange={onShippingAmountChange}
                        showCalculator={false}
                        style={{ width: 140 }}
                    />
                </SummaryRow>

                <Flex justify='space-between' align='center' style={{ paddingTop: 12 }}>
                    <Text strong style={{ fontSize: 15 }}>Tổng tiền</Text>
                    <Text strong style={{ fontSize: 17 }}>{formatCurrency(data.total_amount)}</Text>
                </Flex>
            </Space>
        </Card>
    );
};

export default OrderSummaryCardMobile;
